import '@40seas/frontend/common/theme';
import { SvgIcon } from '@mui/material';
import { IconColor, IconProps, IconSize } from './types';

export const withIconWrapper =
    (component: React.ElementType) =>
    ({ color = 'inherit', size = 'medium', border, background = false, disabled, sx }: IconProps) => {
        if (!component) {
            return null;
        }
        const paddingSize = border ? getPaddingSize(size) : undefined;
        const backgroundColor = background && disabled ? 'neutral.light' : getBackgroundColor(background, color);
        const mainColor = disabled ? 'text.disabled' : color ? getMainColor(color) : 'inherit';
        const borderRadius = getBorderRadius(size);

        return (
            <SvgIcon
                component={component}
                inheritViewBox
                size={size}
                padding={paddingSize}
                color={mainColor}
                sx={{
                    boxSizing: 'content-box',
                    padding: paddingSize,
                    borderWidth: border ? 1 : 0,
                    borderStyle: 'solid',
                    borderColor: 'dividerDark',
                    borderRadius: borderRadius,
                    backgroundColor: backgroundColor,
                    ...sx,
                }}
            />
        );
    };

const getBackgroundColor = (background: boolean, color: string) => {
    if (!background) return undefined;
    if (color === 'text') return 'neutral.light';
    return `${color}.light`;
};

const getBorderRadius = (size: string) => {
    if (size === 'tiny' || size === 'small') return 0.5;
    if (size === 'medium' || size === 'large') return 1;
    return 0;
};

const getMainColor = (color: IconColor) => {
    if (color === 'text') return 'text.primary';
    return color;
};

const getPaddingSize = (size: IconSize) => {
    switch (size) {
        case 'tiny':
            return 0.25;
        case 'small':
            return 0.5;
        case 'medium':
            return 0.75;
        case 'large':
            return 1;
    }
};
